import { useTDAuthentication } from "auth/AuthenticationProvider";
import FaxJobSummary from "components/fax-job-summary/FaxJobSummary";
import JobSummary from "components/job-summary/JobSummary";
import MainContainer from "components/MainContainer";
import Mailbox from "components/messages/MailBox";
import AccountSettings from "components/settings/AccountSettings";
import { Navigate, Route, Routes, Outlet } from "react-router-dom";
import Jobs from "components/jobs/Jobs";
import Reports from "components/reports/Reports";
import { getPageKey } from "helpers/utils";
import { AudioPlayerProvider } from "components/job-summary/AudioPlayerContext";
import DscribeGuide from "components/vscribe-guides/DscribeGuide";
import VscribeGuide from "components/vscribe-guides/VscribeGuide";

const WebDRouter = () => {
  const { webDUser } = useTDAuthentication();
  const pageKey = getPageKey(webDUser?.user.landingPage);

  return (
    <Routes>
      <Route path="/guides/vscribeplus-d" element={<DscribeGuide />} />
      <Route path="/guides/vscribeplus-v" element={<VscribeGuide />} />
      <Route element={
        <MainContainer>
          <Outlet />
        </MainContainer>
      }>
        <Route path="/" element={<Navigate to={`/jobs`} />} />
        <Route path="/jobs" element={<Jobs page={pageKey} />} />
        <Route path="/job-summary" element={<AudioPlayerProvider><JobSummary /></AudioPlayerProvider>} />
        <Route path="/fax-summary" element={<FaxJobSummary />} />
        <Route path="/messages" element={<Mailbox />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/settings" element={<AccountSettings />} />
        <Route path="*" element={<p>404 Error - Nothing here...</p>} />
      </Route>
    </Routes> 
  );
};

export default WebDRouter;
